import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "CustomerChannel" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { ref } from 'vue'
import { usePageModal } from '@/hooks/usePageModal'
import PageModal from "@/components/PageModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerChannel',
  setup(__props) {

const otherInfo = ref({})

const modalTitle = ref('新增')

const newCb = () => {
  modalTitle.value = '新增渠道'
  modalConfig.formItems.forEach(item => {
    item.isDisabled = false
    if (item.field === 'channelType') {
      item.rules.required = true
    }
  })
}

const queryParam = {
  name: ''
}

const resetCb = () => {
  modalConfig.formItems.forEach(item => {
    if (item.field === 'channelType') {
      item.rules.required = false
    }
    if(item.field!== 'thirdPartyAlias') {
      item.isDisabled = true
    }
  })
  return queryParam
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  resetCb
)

const validOtherInfo = () => {
  if (pageModalRef.value) {
    pageModalRef.value.formData.channelName =
      pageModalRef.value.formData.channelName.trim()
  }
  return true
}

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "customerChannel",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, {
      channelType: _withCtx(({ row }) => [
        (row.channelType === 'PHONE')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "电话资源"))
          : (row.channelType === 'DRAINAGE')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "第三方引流"))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "customerChannel",
      otherInfo: otherInfo.value,
      validOtherInfo: validOtherInfo
    }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})